const TableRowSkeleton = () => (
  <tr className="w-full border-b border-gray-100 last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg">
    {/* File Name */}
    <td className="whitespace-nowrap px-6 py-3">
      <div className="h-6 w-32 rounded bg-gray-200"></div>
    </td>
    {/* Description */}
    <td className="px-6 py-3">
      <div className="h-6 w-64 rounded bg-gray-200"></div>
    </td>
    {/* Content Type */}
    <td className="px-6 py-3">
      <div className="h-6 w-24 rounded bg-gray-200"></div>
    </td>
    {/* Size */}
    <td className="px-6 py-3">
      <div className="h-6 w-20 rounded bg-gray-200"></div>
    </td>
    {/* Play */}
    <td className="px-6 py-3">
      <div className="h-6 w-16 rounded bg-gray-200"></div>
    </td>
    {/* Actions */}
    <td className="whitespace-nowrap px-6 py-3">
      <div className="flex justify-end gap-2">
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      </div>
    </td>
  </tr>
);

const MobileCardSkeleton = () => (
  <div className="mb-2 w-full rounded-md bg-white p-4">
    <div className="flex items-center justify-between border-b pb-4">
      <div>
        <div className="mb-2 h-6 w-32 rounded bg-gray-200"></div>
        <div className="h-5 w-48 rounded bg-gray-200"></div>
      </div>
    </div>
    <div className="flex w-full items-center justify-between pt-4">
      <div>
        <div className="h-4 w-16 rounded bg-gray-200 mb-1"></div>
        <div className="h-5 w-24 rounded bg-gray-200"></div>
      </div>
      <div>
        <div className="h-4 w-8 rounded bg-gray-200 mb-1"></div>
        <div className="h-5 w-16 rounded bg-gray-200"></div>
      </div>
      <div className="flex justify-end gap-2">
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      </div>
    </div>
  </div>
);

export default function AppFilesSkeleton() {
  return (
    <div className="animate-pulse mt-6">
      {/* Mobile layout */}
      <div className="lg:hidden">
        <MobileCardSkeleton />
        <MobileCardSkeleton />
        <MobileCardSkeleton />
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">File Name</th>
            <th scope="col" className="px-6 py-3">Description</th>
            <th scope="col" className="px-6 py-3">Content Type</th>
            <th scope="col" className="px-6 py-3">Size</th>
            <th scope="col" className="px-6 py-3">Play</th>
            <th scope="col" className="px-6 py-3"><span className="sr-only">Edit</span></th>
          </tr>
        </thead>
        <tbody className="bg-white">
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
        </tbody>
      </table>
    </div>
  );
}
